import { render, staticRenderFns } from "./ResultC.vue?vue&type=template&id=341b72b2&"
import script from "./ResultC.vue?vue&type=script&lang=js&"
export * from "./ResultC.vue?vue&type=script&lang=js&"
import style0 from "./ResultC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports